module.exports = __webpack_public_path__ + "img/1581418497.6cdfff31.jpg";